import { NoticeType } from "../types/notice";
import {
  noticeTypeFromDraftType,
  restoredUploadedFilesFromDraft,
  restoreNoticeForm,
} from "../domain/notices/noticePayload";

export type DraftRestoreUploadedFile = {
  fileUrl: string;
  fileName: string;
  contentType: string;
  size: number;
};

export type DraftRestorePayload = {
  noticeType: NoticeType;
  initialFormData: {
    title?: string;
    body?: string;
    eventBackgroundImage?: string;
    eventFontColor?: string;
    targetSubcircle?: string;
    isUrgent?: boolean;
    eventStartDate?: Date | null;
    eventStartTime?: string;
    eventEndDate?: Date | null;
    eventEndTime?: string;
    eventLocation?: string;
    audience?: string;
    draftId?: string;
    uploadedFiles?: DraftRestoreUploadedFile[];
    pollOptions?: Array<{ optionId: string; label: string; order: number }>;
    pollClosesAt?: string;
    pollMode?: "standard" | "claim";
  };
};

type DraftAttachment = {
  url?: string;
  name?: string;
  type?: string;
  size?: number;
};

export type DraftRestoreSource = {
  type: string;
  title?: string;
  body?: string;
  eventBackgroundImage?: string;
  eventFontColor?: string;
  targetSubcircle?: string;
  isUrgent?: boolean;
  eventStartDate?: string;
  eventStartTime?: string;
  eventEndDate?: string;
  eventEndTime?: string;
  eventLocation?: string;
  noticeId?: string;
  uploadedFiles?: DraftRestoreUploadedFile[];
  attachments?: DraftAttachment[];
  pollOptions?: Array<{ optionId: string; label: string; order: number }>;
  pollClosesAt?: string;
  pollMode?: "standard" | "claim";
};

export { noticeTypeFromDraftType, restoredUploadedFilesFromDraft };

export const buildDraftRestorePayload = (
  draft: DraftRestoreSource,
): DraftRestorePayload => restoreNoticeForm(draft, "draft");
